import { AfterViewChecked, Component, ElementRef, Inject, Input, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HomeController } from '@shared/src/controllers/home/home.controller';
import { RouteController } from '@shared/src/controllers/route/route.controller';
import { TotemController } from '@shared/src/controllers/totem/totem.controller';
import { TotemRouteParamsDto } from '@shared/src/controllers/totem/TotemRouteParamsDto';
import { HLong } from '@shared/src/datatypes/HLong';
import { RouteCardDto } from '@shared/src/dtos/route/RouteCardDto';
import { environment, HString, PhaseCardDto, PhaseController, SecurityController, ShipmentCardDto, ShipmentController } from '@shared/src/public-api';

@Component({
  selector: 'shared-route-links',
  templateUrl: './shared.route.links.component.html',
  styleUrls: ['./shared.route.links.component.scss'],
})
export class SharedRouteLinksComponent implements AfterViewChecked {

  public useIonic: boolean = false;
  public hardmanUser: boolean = false;

  ngAfterViewChecked() {
  }

  constructor(
    @Inject('HomeController') public homeController: HomeController,
    public activatedRoute: ActivatedRoute,
    public totemController: TotemController,
    public router: Router,
    public routeController: RouteController,
    public shipmentController: ShipmentController,
    public phaseController: PhaseController,
    @Inject("SecurityController") securityController: SecurityController
  ) {
    if (homeController.useIonic)
      this.useIonic = homeController.useIonic();

    if (securityController) {
      securityController.isHardManUser().subscribe(a => {
        this.hardmanUser = a;
      });
    }
  }



  public __route: RouteCardDto;
  @Input()
  public set route(value: RouteCardDto) {
    if (this.__route === value) return;
    this.__route = value;
    if (this.__route == null) {
      this.__routeId = 0;
    } else {
      this.__routeId = value.routeId;

      this.shipmentController.getShipmentsInRouteByRouteId(value.routeId).subscribe(data => {
        this.shipments = data;
      });
      this.phaseController.getSlotPhasesByRoute(value.routeId).subscribe(data => {
        this.phases = data;
        this.precargarTotemLinks(this.phases);
      });
    }
  }
  public get route(): RouteCardDto { return this.__route; }

  public __routeId: number;
  @Input()
  set routeId(value: number) {
    if (this.__routeId === value) return;
    this.__routeId = value;
    this.routeController.getRoute(value).subscribe(route => {
      this.route = route;
    });

  }
  get routeId(): number { return this.__routeId; }

  setShowTotemTitle() {
    this.showTotemTitle = true;
    return '';
  }

  public showTotemTitle: boolean = false;
  public shipments: ShipmentCardDto[];
  public phases: PhaseCardDto[];

  public __phase: PhaseCardDto;
  @Input()
  public set phase(value: PhaseCardDto) {
    if (this.__phase === value) return;
    this.__phase = value;
    if (this.__phase == null) {
      this.__phaseId = 0;
    } else {
      this.__phaseId = value.phaseId;
      this.shipmentController.getShipmentsByPhaseId(value.phaseId).subscribe(data => {
        this.shipments = data;
      });
      this.routeController.getRoute(value.routeId).subscribe(route => {
        if (route)
          this.uuidPhase = route.uuidExwork;
      });
      this.precargarTotemLinks([this.__phase]);
    }
  }
  public get phase(): PhaseCardDto { return this.__phase; }

  public __phaseId: number;
  @Input()
  set phaseId(value: number) {
    if (this.__phaseId === value) return;
    this.__phaseId = value;
    this.phaseController.getPhase(value).subscribe(phase => {
      this.phase = phase;
    });
  }
  get phaseId(): number { return this.__phaseId; }

  public optionExpanded: string = "";
  uuidPhase: string = null;


  public totemRoute: TotemRouteParamsDto;
  private precargarTotemLinks(phases: PhaseCardDto[]) {
    if (!HLong.isNullOrNullLong(this.routeId)) {
      // Ruta
      this.totemController.getUrisByRoute(this.routeId)
        .subscribe(v => {
          this.totemRoute = v;
        });
    }
    if (phases != null) {
      phases.forEach(p => {
        this.totemController.getUrisByPhase(p.phaseId)
          .subscribe(v => {
            p.totemPhase = v;
          });
      });
    }
  }


  goTo(uri: string) {
    if (uri && uri != "")
      window.open(uri, "_blank");
  }

  onClickLinkOption(option: string, shipment: ShipmentCardDto, phase: PhaseCardDto) {
    const currentPhase = phase ?? this.phase;

    switch (option) {
      case "terceros":
        if (currentPhase) {
          if (this.uuidPhase != null)
            window.open(this.homeController.getRouteToExWork(this.uuidPhase), "_blank");
        } else
          window.open(this.homeController.getRouteToExWork(this.route.uuidExwork), "_blank");
        break;

      case "track":
        if (shipment)
          window.open("/track/shipment/" + shipment.readUuid, "_blank");
        break;

      case "signatureExit":
        if (currentPhase)
          window.open(`/operation/activeslots?routeId=${currentPhase.routeId}&option=phaseSignatureCMR&phaseId=${currentPhase.phaseId}`, "_blank");
        break;


      default:
        alert(option);
        break;
    }
  }

  getLink(option: string, shipment?: ShipmentCardDto, phase?: PhaseCardDto): string {
    const currentPhase = phase ?? this.phase;

    switch (option) {
      case "terceros":
        return currentPhase
          ? this.homeController.getRouteToExWork(this.uuidPhase)
          : this.homeController.getRouteToExWork(this.route.uuidExwork);

      case "track":
        return shipment ? environment.BASE_URI + `/track/shipment/${shipment.readUuid}` : null;

      case "signatureExit":
        return currentPhase
          ? environment.BASE_URI + `/operation/activeslots?routeId=${currentPhase.routeId}&option=phaseSignatureCMR&phaseId=${currentPhase.phaseId}`
          : null;


      default:
        return null;
    }
  }

  getString(a: string) {
    if (HString.isNullOrNullString(a))
      return "---";
    return a;
  }


  public pretty(value) {
    return JSON.stringify(value);
  }
}
